import { Box, useTheme } from "@mui/material";
import Shbutton from "../../../../components/theme/buttons/Shbutton";

import Text from "../../../../components/theme/text/Text";
import { tokens } from "../../../../theme";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import ShLabel from "../../../../components/theme/label/ShLabel";
import { useGetReturnsQuery, useBulkUpdateReturnsMutation, useExportReturnsMutation } from "../../../../newapi/inbound/returnsSlice";
import { Close, CloseOutlined, PhonelinkOutlined, DownloadOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RelationReturnCard } from "../../../../components/global/cards/inbounds/ReturnCards";
import ButtonGroup from "../../../../components/theme/buttons/ButtonGroup";
import ShDataGrid2 from "../../../../components/theme/datagrid2/ShDataGrid2";
import SidepanelLoader from "../../../../components/theme/sidepanel2/SidepanelLoader";
import ShLabelSkeleton from "../../../../components/theme/skeleton/ShLabelSkeleton";
import ShDoubleTextSkeleton from "../../../../components/theme/skeleton/ShDoubleTextSkeleton";
import ShTextSkeleton from "../../../../components/theme/skeleton/ShTextSkeleton";
import { useGetRelationQuery } from "../../../../newapi/global/relation/relationSlice";
import { getReturnStateData } from '../../../../utils/labelColorText';
import EMGeneralExplainerBox from "../../../../components/global/ModalsPopover/explainers/EMGeneralExplainerBox";
import SHQuickAction from "../../../../components/theme/Modal/SHQuickAction";
import { general_states } from "../../../../utils/staticEnums";
import ShDataGridSelectedActions from "../../../../components/theme/datagrid2/ShDataGridSelectedActions";
import DropdownButton from "../../../../components/theme/buttons/DropdownButton";
import { showToastMessageUpdateRequest, showToastPromise } from "../../../../utils/toasts";
import ShCopyButton from "../../../../components/theme/ShCopy";
import { RELATION_ORDERS_DEFAULT } from "../../../../components/theme/datagrid3/groupingPresets/GroupingPresets";
import { RELATION_RETURNS_FAMILY } from "../family";
import MConfirmation from "../../../../components/global/Modals/MConfirmation";
import MCreateReturn from "../../../../components/global/Modals/MCreateReturn";
import { useGetAllReturnShipperProfilesSelectQuery } from "../../../../newapi/shipper/shipperprofileSlice";
import { selectUserPermission } from "../../../../newapi/user/authentication/authSlice";
import { UserPrivileges } from "../../../../utils/permissions";
import AddIcon from '@mui/icons-material/Add';
import HomeIcon from '@mui/icons-material/Home';

const SpReturnDetails = SidepanelLoader(() => import("../../../../components/global/Sidepanels/SpReturnDetails/SpReturnDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <ButtonGroup version={2}>
            <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "grey"}
                onClick={() => props.exportReturns()}
                endIcon={<DownloadOutlined/>}
                variant="contained"
                isLoading={props.isExporting}
            >
                {t("export")}
            </Shbutton>
            {props.canCreate &&
                <Shbutton
                    className={"group-btn"}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    onClick={() => props.handleCreateOpen()}
                    endIcon={<AddIcon/>}
                    variant="contained"
                >
                    {t("create_return_without_order")}
                </Shbutton>
            }
            {/* <Shbutton
                className={"group-btn"}
                color={theme.palette.mode === "dark" ? "primaryGrey" : "primaryGrey"}
                onClick={() => props.handlePortalOpen()}
                endIcon={<PhonelinkOutlined/>}
                variant="contained"
            >
                {t('portal')}
            </Shbutton> */}
        </ButtonGroup>
    )
}

let gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,

};

const ReturnsExpected = (props) => { 
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [isExtended, setIsExtended] = useState(false);
    const id = useSelector((state) => state.settings.environment.selectedId);
    const [spLoading, setSpLoading] = useState();

    // Multi-select state
    const [selectedItems, setSelectedItems] = useState([]);
    const [bulkUpdateReturns, { isLoading: updateLoading }] = useBulkUpdateReturnsMutation();
    const [confirmRejectAllOpen, setConfirmRejectAllOpen] = useState(false);

    const [config, setConfig] = useState({
        state:[general_states.ACTIVE],
    });

    const [filter, setFilter] = useState({"state":["active"]});
    const [exportReturns, {isLoading: isExporting}] = useExportReturnsMutation();

    const hasReturnManagePermission = useSelector((state) =>
        selectUserPermission(state, [UserPrivileges.RP_RETURN_MANAGE])
    );

    // A return label can only be made when a return shipper profile exists to make it with,
    // so without one the trigger is not rendered at all.
    const { data: returnProfiles = [], isLoading: profilesLoading } = useGetAllReturnShipperProfilesSelectQuery();
    const canCreateReturn = hasReturnManagePermission && !profilesLoading && returnProfiles.length > 0;

    const [createOpen, setCreateOpen] = useState(false);
    const handleCreateOpen = () => setCreateOpen(true);
    const handleCreateClose = () => setCreateOpen(false);

    const onSelected = (selectedItems) => {
        setSelectedItems(selectedItems);
    };

    const handleSetRejectAll = async () => {
        if (selectedItems.length === 0) return;

        try {
            await bulkUpdateReturns({
                returnIds: selectedItems,
                rejectAll: true
            }).unwrap();

            setSelectedItems([]); // Clear selection after successful update
            showToastMessageUpdateRequest(t, { success: true, message: t('returns_rejected_successfully') });
        } catch (error) {
            console.error('Failed to reject returns:', error);
            showToastMessageUpdateRequest(t, { success: false, error: error.error });
        }
    };

    const exportReturnsCall = async () => {
        const exportPromise = exportReturns(filter).unwrap();

        showToastPromise(
            exportPromise,
            t,
            {
                pending: t('export_processing') || 'Processing export...',
                success: t('export_success') || 'Export completed successfully',
                error: t('export_failed') || 'Export failed'
            }
        ).then((result) => {
            if (result.processing) {
                console.log('Export is being processed in background. Export ID:', result.exportId);
            }
        }).catch((error) => {
            console.error("Export failed", error);
        });
    }

    useEffect(() => {
        props.replaceView({
            ...props.config,
            gridOptions: gridOptions,
            mobileActions: <GridActions isExporting={isExporting} exportReturns={exportReturnsCall} canCreate={canCreateReturn} handleCreateOpen={handleCreateOpen}></GridActions>,
        });

        return () => {

        }
    },[isExporting,exportReturnsCall,canCreateReturn]);

    const [relationId, setRelationId] = useState();
    const { data: relation } = useGetRelationQuery(relationId, {
        skip: !relationId
    });
    
    const handlePortalOpen = () => {
        if(!relation){
            setRelationId(id);
        } else {
            window.open(`https://www.clicktoreturn.com/${relation.portalCode}`, '_blank');
        }
    }


    const [returnId, setReturnId] = useState();
    const returnIdRef = useRef(returnId);
    
    const getReturnDetails = (params) => {
        if (!params) return;
    
        const newreturnId = parseInt(params.row.id);
        // Only update state if the returnId has actually changed
        if (returnIdRef.current !== newreturnId) {
            
            if(!spLoading) {
                setSpLoading(true);
            }
            setReturnId(newreturnId);
            returnIdRef.current = newreturnId; // Update the ref to the new value
        }
        setIsExtended(true);
    };

    const columns = [
        {field: "barcode", headerName: t("reference"),flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                let reference;
                if(params.row.rejectAll){
                    reference = (
                   
                    <SHQuickAction
                        component={ 
                            <Box
                                sx={{
                                    px:1.5,
                                    display:"flex",
                                    flexDirection:"column"
                                }}
                            >
                                <Text light>{t("declared_unsellable")}</Text>
                                <Text>
                                    {t("declared_unsellable_text")}
                                </Text>
                            </Box>
                        }
                    >
                        {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                            <Box
                            aria-owns={anchorEl ? "simple-popover" : undefined}
                            aria-haspopup="true"
                            onMouseEnter={onMouseEnter}
                            onMouseLeave={onMouseLeave}
                            onTouchStart={onTouchStart}
                            sx={{
                                height:32,
                                py: 1.5,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                cursor: "pointer",
                                transition:"250ms",
                                gap: 1.5,
                                borderRadius: 12,
                                "&:hover": {
                                    px: 1.5,
                                    background: colors.grey[50],
                                    transition:"250ms",
                                },
                            }}
                          >
                             <Close sx={{color: colors.red[400]}}/>
                             <Text>{params.row.order?.barcode ? "R" + params.row.order?.barcode : t("imported")}</Text>
                             </Box>
                        )}
                    </SHQuickAction>)
                } else {
                    reference = params.row.order?.barcode ? "R" +params.row.order?.barcode : params.row.reference || t("imported");
                }

                if(!params.row.toAlternativeAddress) {
                    return reference;
                }

                return (
                    <Box
                        sx={{
                            display:"flex",
                            alignItems:"center",
                            gap:1.5,
                        }}
                    >
                        {reference}
                        <SHQuickAction
                            disableScrollLock={true}
                            component={
                                <Box
                                    sx={{
                                        px:1.5,
                                        display:"flex",
                                        flexDirection:"column"
                                    }}
                                >
                                    <Text light>{t("delivered_to_alternative_address")}</Text>
                                </Box>
                            }
                        >
                            {({anchorEl,onMouseEnter,onMouseLeave,onTouchStart}) => (
                                <Box
                                    aria-owns={anchorEl ? 'simple-popover' : undefined}
                                    aria-haspopup={false}
                                    onMouseEnter={onMouseEnter}
                                    onMouseLeave={onMouseLeave}
                                    onTouchStart={onTouchStart}
                                    sx={{
                                        background:theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100],
                                        height:32,
                                        width:32,
                                        color: colors.txt['secondary'],
                                        display:'flex',
                                        alignItems:'center',
                                        justifyContent:'center',
                                        borderRadius:4,
                                    }}
                                >
                                    <HomeIcon fontSize='small'/>
                                </Box>
                            )}
                        </SHQuickAction>
                    </Box>
                );
            }
        },
        {field: "webshopreference", headerName: t("webshop_reference"),flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box>
                            <Text>{params.row.order?.webshopreference ?? params.row.webshopreference}</Text>
                            <br/>
                            <Text light>{params.row.webshop_description}</Text>
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.order?.webshopreference ?? params.row.webshopreference}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "name", headerName: t("name"),flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box sx={{
                        minWidth:"100%",
                        height:"100%",
                        display:"flex",
                        alignItems:"center",
                        position:"relative",
                        whiteSpace:"nowrap",
                        wordBreak:"keep-all",
                        textOverflow:"ellipsis",
                        overflow:"hidden",
                        ".copyel": {
                            opacity:0,
                        },
                        "&:hover .copyel": {
                            opacity:1,
                        }
                    }}>
                        <Box>
                            <Text>{params.row.name}</Text>
                        </Box>
                        <ShCopyButton 
                            styles={{button:{
                                background:theme.palette.mode === "dark" ? colors.grey[600] :  colors.grey[200],
                                color: colors.txt["primary"],
                                "&:hover" : {
                                    background:theme.palette.mode === "dark" ? colors.grey[500] :colors.grey[300],

                                }
                            }}} 
                            sx={{position:"absolute",right:0,zIndex:3000}} 
                            className={"copyel"} 
                            closeAfter={1500} 
                            value={params.row.name}
                        ></ShCopyButton>
                    </Box>
                );
            }
        },
        {field: "lineCount", headerName: t("sku_count"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.lineCount;
            }
        },        

        {field: "productCount", headerName: t("items"),flex:1,
            sortable:false,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.productCount;
            }
        },
        {
            field: "state", 
            headerName: t("status"),
            flex:2,
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShLabelSkeleton/>
                }
                const { labelcolor, labeltext } = getReturnStateData(params.row.state, theme);
              
                return (
                    <ShLabel size={32} palette="normal" variant={labelcolor}>
                      {t(labeltext)}
                    </ShLabel>
                  );
              }
        },
        {
            field: "createdAt", 
            headerName: t("created_at"),
            flex:2,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                let date = new Date(params.row.createdAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            },
            grouping: RELATION_ORDERS_DEFAULT.CREATED_AT,
        },
        {
            field: "updatedAt", 
            headerName: t("last_updated"),
            flex:2,
            shFilter: {
                type: "date"
            },
            renderCell: (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                if(params.row.updatedAt === params.row.createdAt || !params.row.order?.barcode){
                    return <Text light></Text>
                }

                let date = new Date(params.row.updatedAt);
              
                return (
                    <Box>
                        <Text semibold>
                            {date.toLocaleDateString(i18n.language)}
                        </Text><br/>
                        <Text light>
                            {date.toLocaleTimeString(i18n.language,{timeStyle: 'short'})}
                        </Text>
                    </Box>
                );
            },
            grouping: RELATION_ORDERS_DEFAULT.CREATED_AT,
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            renderCell: (params) => {
                return (
                    <RelationReturnCard onClick={() => getReturnDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}/>
                )
            }
        }
    ];

    return (
        <Box height={1} display={"flex"} flexDirection={"column"}>
            {/* <GridActions></GridActions> */}
            <ShDataGrid2 key={theme.palette.mode}
                gridKey={RELATION_RETURNS_FAMILY.EXPECTED.gridKey}
                family={RELATION_RETURNS_FAMILY}
                enableGrouping={true}
                content={useGetReturnsQuery}
                config={config}
                gridActions={<GridActions isExporting={isExporting} exportReturns={exportReturnsCall} canCreate={canCreateReturn} handleCreateOpen={handleCreateOpen}></GridActions>}
                title={t('all_returns') } // Changed from all_inbounds to all_returns
                gridOptions={gridOptions}
                filterObjectChanged={(filterObject) => {
                    setFilter(filterObject?.filter);
                }}
                sortModel={{field: columns[7].field,type:"DESC"}}
                columns={columns}
                onRowClick={getReturnDetails}
                selectable
                // The only bulk action is fully reject, which instructs the fulfilment; a return to an
                // alternative address never reaches it.
                isRowSelectable={(row) => !row.toAlternativeAddress}
                setSelected={onSelected}
                selectedItems={selectedItems}
                selectedActions={
                    <ShDataGridSelectedActions selectedItems={selectedItems}>
                        <DropdownButton
                            onClick={() => setConfirmRejectAllOpen(true)}
                            icon={<Close/>}
                            text={t("set_rejectall")}
                            disabled={updateLoading}
                        />
                    </ShDataGridSelectedActions>
                }
            >
            </ShDataGrid2>

            {spLoading &&
                    <SpReturnDetails // Changed from SpInboundDetails to SpReturnDetails
                        isExtended={isExtended}
                        setIsExtended={setIsExtended}
                        returnId={returnId}
                    />
            }

            <MCreateReturn
                open={createOpen}
                handleClose={handleCreateClose}
                profiles={returnProfiles}
            />

            <MConfirmation
                open={confirmRejectAllOpen}
                handleClose={() => setConfirmRejectAllOpen(false)}
                confirm={handleSetRejectAll}
                title={t("set_rejectall")}
                subtitle={t("set_rejectall_confirm")}
            />

        </Box>
    );
}

export default ReturnsExpected; 
